<template>
	<div class="devices">
		<Nav></Nav>
		<HomeNav currentTab="1" :deviceLength="list.length"></HomeNav>
		<div class="device-setting-wrap">
			<div class="device-setting">
				<div class="total-device">
					受控设备（{{ listOnline.length }}/{{ list.length }}）
					<div class="add-btn" @click="addDeviceClick">
						<div class="add-icon"></div>
						添加设备
					</div>
				</div>
				<div class="line"></div>
				<div class="device-list">
					<div
						:class="{ 'device-item': true }"
						v-for="(item, index) in list"
						:key="index"
					>
						<div class="item-top">
							<div
								:class="{
									'item-icon': true,
									'item-icon2': item.term.status == 1,
									'item-icon-ly': item.dtype == 2,
									'item-icon-ly2':
										item.dtype == 2 &&
										item.term.status == 1,
									'item-icon-pc': item.dtype == 3,
									'item-icon-pc2':
										item.dtype == 3 &&
										item.term.status == 1,
								}"
							></div>
							<div class="dev-name-wrap" v-if="!item.isEdit">
								<div class="dev-name">
									{{
										item.term.comment &&
										item.term.comment != "0"
											? item.term.comment
											: item.term.name
											? item.term.name
											: item.peerid
									}}
								</div>
								<!--								<div-->
								<!--									:class="{-->
								<!--										'dev-name-icon': true,-->
								<!--										'dev-name-icon2': !item.comment,-->
								<!--									}"-->
								<!--								></div>-->
							</div>
							<div class="dev-name-edit-wrap" v-else>
								<input
									type="text"
									@blur="saveClick(item)"
									:id="index"
									v-model="item.comment"
								/>
							</div>
							<!-- <div class="device-name">
								设备名：
								{{
									item.term.comment
										? item.term.comment
										: item.term.name
										? item.term.name
										: item.peerid
								}}
							</div> -->
						</div>
						<div class="device-ip">
							IP地址：{{
								item.ip ? $common.ipConvert(item.ip) : ""
							}}
						</div>
						<div class="manage-btn" @click="settingClick(item)">
							管理
						</div>
					</div>
				</div>
				<AddDevice
					v-if="isAddDevice"
					@closeAddDeviceClick="closeAddDeviceClick"
					@getBindget="getBindget"
					:deviceLength="list.length"
				></AddDevice>
			</div>
		</div>
	</div>
</template>

<script>
import Nav from "@/components/Common/Nav.vue";
import HomeNav from "@/components/Common/HomeNav.vue";
import { mapActions } from "vuex";

import AddDevice from "@/components/device/AddDevice.vue";
export default {
	components: {
		Nav,
		HomeNav,
		AddDevice,
	},
	data: function () {
		return {
			list: [], //设备列表
			listOffline: [], //离线设备列表
			listOnline: [], //在线设备列表

			isAddDevice: false,
		};
	},
	"$store.state.isLoadForBind": function () {
		this.getBindget();
	},
	methods: {
		...mapActions([
			"bindget",
			"nodeDeviceInfo",
			"deviceName",
			"sendUserlog",
		]),
		settingClick: function (item) {
			let _that = this;
			_that.sendUserlog(["setting_click", item.peerid]);
			// _that.$router.push({
			// 	path: "/home/node/manage",
			// 	query: { cur_pid: item.peerid },
			// });
			_that.$store.state.deviceForSetting = item;
			_that.$router.push({
				name: "DeviceSetting",
				params: { device: item },
			});
		},
		goInfoClick: function (data) {
			let _that = this;
			_that.$router.push({
				name: "DeviceInfo",
				params: { device: data },
			});
		},
		closeAddDeviceClick: function () {
			let _that = this;
			_that.isAddDevice = false;
		},
		addDeviceClick: function () {
			let _that = this;
			_that.isAddDevice = true;
		},
		saveClick: function (item) {
			let _that = this;
			_that.$set(item, "isEdit", false);
			_that.deviceName([
				item.peerid,
				item.comment,
				function (err, data) {
					if (data && data.rtn == 0) {
						console.log("保存成功");
						_that.getBindget();
					} else {
						// _that.$set(item, "comment", "");
						console.log("保存失败");
					}
				},
			]);
		},
		editClick: function (data, index) {
			let _that = this;
			_that.$set(data, "isEdit", true);
			setTimeout(function () {
				document.getElementById(index).focus();
			}, 500);
		},

		getBindget: function () {
			let _that = this;
			_that.list = [];
			_that.bindget([
				function (err, data) {
					if (data && data.terms && data.terms.length > 0) {
						_that.list = data.terms;
						_that.listOffline = [];
						_that.listOnline = [];

						for (
							let index = 0;
							index < _that.list.length;
							index++
						) {
							const element = _that.list[index];
							let pidInfo = _that.$common.getInfoByPid(
								element.peerid
							);
							if (pidInfo.dname == "NAS") {
								element.dtype = 1;
							} else if (pidInfo.dname == "路由器") {
								element.dtype = 2;
							} else if (pidInfo.dname == "pc") {
								element.dtype = 3;
							}

							if (element.term && !element.term.name) {
								element.term.name =
									pidInfo.cname + pidInfo.dname;
							}

							element.ip = "";
							element.mac = "";
							if (element.term && element.term.nic) {
								let nic = _that.$common.getNicByNics(
									element.term.nic
								);
								if (nic) {
									element.ip = nic.ipv4n;
									element.mac = nic.mac;
								}
							}
							if (
								element.term.status &&
								element.term.status == 1
							) {
								_that.listOffline.push(element);
							} else {
								_that.listOnline.push(element);
							}
							_that.getNodeDeviceInfo(element);
						}
					}
				},
			]);
		},
		getNodeDeviceInfo: function (item) {
			let _that = this;
			_that.nodeDeviceInfo([
				item.peerid,
				function (err, data) {
					if (data && data.rtn == 0) {
						if (data.data.name && data.data.name != "0") {
							_that.$set(item, "comment", data.data.name);
						} else {
							_that.$set(item, "comment", "");
						}
					}
				},
			]);
		},
	},
	activated() {
		let _that = this;
		_that.getBindget();
	},
};
</script>

<style lang="less" scoped>
.device-setting-wrap {
	background-color: #f2f5fa;
	width: 960px;
	height: 426px;
	overflow: hidden;
}

.device-setting {
	margin: 0 auto;
	width: 940px;
	height: 418px;
	box-sizing: border-box;
	border-radius: 4px;
	// background-image: url("../assets/device/bg.png");
	background-repeat: no-repeat;
	background-size: 100% 100%;
	background-image: url(../assets/setting/bg.png);
	background-color: #ffffff;
	background-size: 100% 100%;
	background-repeat: no-repeat;
	background-size: 100% 100%;
	background-position: center;
	box-sizing: border-box;
	border: 1px solid #dddddd;
	border-top: none;
	border-top-left-radius: 0px;
	border-top-right-radius: 0px;
	.add-btn {
		position: absolute;
		right: 35px;
		top: 12px;
		width: 116px;
		height: 32px;
		background-color: #123874;
		border-radius: 36px;
		text-align: center;
		font-weight: 700;
		font-size: 14px;
		line-height: 32px;
		color: #ffffff;
		cursor: pointer;
		.add-icon {
			display: inline-block;
			margin-top: 5px;
			vertical-align: top;
			width: 20px;
			height: 20px;
			background-image: url("../assets/device/add.svg");
			background-repeat: no-repeat;
			background-size: 100% 100%;
		}
	}
	.add-btn:hover {
		opacity: 0.9;
	}
	.total-device {
		margin-left: 24px;
		line-height: 56px;
		font-weight: 700;
		font-size: 16px;
		color: #1a1a1a;
		position: relative;
	}
	.line {
		margin: 0 auto;
		width: 884px;
		height: 1px;
		background-color: #c9d9e4;
	}
	.device-list {
		margin: 0 auto;
		margin-top: 10px;
		margin-left: 9px;
		width: 924px;
		height: 350px;
		overflow: auto;
		.device-item {
			position: relative;
			display: inline-block;
			padding-left: 24px;
			margin: 6px;
			vertical-align: top;
			width: 215px;
			height: 150px;
			background-color: #fcfdff;
			border: 1px solid #d7deec;
			border-radius: 8px;
			box-sizing: border-box;
			overflow: hidden;
			.item-top {
				.item-icon {
					display: inline-block;
					vertical-align: top;
				}
				.dev-name-wrap {
					display: inline-block;
					vertical-align: top;
				}
				.dev-name-edit-wrap {
					display: inline-block;
					vertical-align: top;
				}
			}
			.item-icon {
				margin-top: 24px;
				margin-right: 8px;
				width: 48px;
				height: 48px;
				background-image: url(../assets/device/deviceOn.png);
				background-repeat: no-repeat;
				background-size: 100% 100%;
			}
			.item-icon2 {
				background-image: url(../assets/device/deviceOff.png);
			}
			.item-icon-ly {
				background-image: url(../assets/device/deviceLy.png);
			}
			.item-icon-ly2 {
				background-image: url(../assets/device/deviceLy2.png);
			}
			.item-icon-pc {
				background-image: url(../assets/device/devicePc.png);
			}
			.item-icon-pc2 {
				background-image: url(../assets/device/devicePc2.png);
			}
			.dev-name-wrap {
				margin-top: 35px;
				height: 25px;
				cursor: pointer;
				width: 128px;
				.dev-name {
					display: inline-block;
					vertical-align: top;
					max-width: 100px;
					white-space: nowrap;
					overflow: hidden;
					text-overflow: ellipsis;
					font-weight: 700;
					font-size: 16px;
					line-height: 25px;
					color: #1a1a1a;
				}
				.dev-name-icon {
					display: inline-block;
					margin-left: 6px;
					margin-top: 4px;
					vertical-align: top;
					width: 16px;
					height: 16px;
					background-image: url(../assets/device/edit.svg);
					background-repeat: no-repeat;
					background-size: 100% 100%;
				}
				.dev-name-icon2 {
					margin-left: 0;
				}
			}
			.dev-name-edit-wrap {
				margin-top: 35px;
				width: 128px;
				height: 25px;
				line-height: 25px;
				background-color: #ffffff;
				border: 1px solid rgba(30, 50, 81, 0.5);
				box-shadow: 0px 2px 6px rgba(201, 206, 210, 0.1);
				border-radius: 86px;
				overflow: hidden;
				box-sizing: border-box;
				input {
					padding-left: 12px;
					color: #1e3251;
					width: 100%;
					height: 100%;
					font-size: 14px;
				}
			}
			.device-name,
			.device-ip {
				font-size: 12px;
				line-height: 16px;
				color: #999999;
			}
			.device-name {
				margin-top: 4px;
			}
			.device-ip {
				margin-top: 10px;
			}
			.manage-btn {
				position: absolute;
				left: 0;
				bottom: 0;
				width: 100%;
				height: 36px;
				line-height: 36px;
				border-top: 1px solid #d7deec;
				background: #f3f5f7;
				font-size: 14px;
				color: #666666;
				text-align: center;
			}
			.manage-btn:hover {
				background-color: #dbe4f8;
				cursor: pointer;
			}
		}
		.device-item:hover {
			background-color: #f4f8ff;

			.manage-btn {
				background-color: #f4f8ff;
				color: #203454;
			}
			.manage-btn:hover {
				background-color: #dbe4f8;
			}
		}
	}
}
</style>